module.exports = require('./lib/addons/FluxComponent');



//////////////////
// WEBPACK FOOTER
// ./~/flummox/component.js
// module id = 234
// module chunks = 0